import React, { useRef, useEffect, useState } from "react";
import cep from "cep-promise";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, InputProps, Dimmer, Label, Input, Segment, Icon } from "semantic-ui-react";
import MaskedInput from "../../components/MaskedInput";
import { toast } from "react-toastify";

import ModalApp from "../ModalApp";
import ImageZoom from "../ImageZoom";
import ModalYesNo from "../ModalYesNo";
import CustomLoader from "../CustomLoader";

interface State {
    nome: string;
    consulta: string;
    celular: string;
    nascimento: string;
    cpf: string;
    rg: string;
    cep: string;
    numero: string;
    bairro: string;
    logradouro: string;
    complemento: string;
    cidade: string;
    uf: string;
    apiErrors: IAliancaErrors;
}

interface Props {
    onSuccess: () => void;
    url: string;
    status: string;
    grId?: string;
    gsId?: string;
    rpId?: string;
}

const initialState: State = {
    nome: "",
    consulta: "",
    celular: "",
    nascimento: "",
    cpf: "",
    rg: "",
    cep: "",
    numero: "",
    bairro: "",
    logradouro: "",
    complemento: "",
    cidade: "",
    uf: "",
    apiErrors: { errors: [] }
}


const CadastroPessoa: React.FC<Props> = ({ onSuccess, url, status, grId, gsId, rpId }) => {

    const fileInputRef = useRef<HTMLInputElement>(null);

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles])

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const handleSubmitForm = async (url: string, status: string, grId?: string, gsId?: string, rpId?: string) => {
        if (selectedFiles.length >= 3 || rpId) { //2023-03-01 João
            try {
                setLoading(true);

                const data = new FormData();

                data.append("nome", state.nome);
                data.append("consulta", state.consulta);
                data.append("celular", state.celular);
                data.append("nascimento", state.nascimento);
                data.append("cpf", state.cpf);
                data.append("rg", state.rg);
                data.append("cep", state.cep);
                data.append("numero", state.numero);
                data.append("bairro", state.bairro);
                data.append("logradouro", state.logradouro);
                data.append("complemento", state.complemento);
                data.append("cidade", state.cidade);
                data.append("uf", state.uf);
                data.append("status", status);
                data.append("devedor", "0");
                data.append("gerenteregionalid", grId || "");
                data.append("gerentesetorid", gsId || "");
                data.append("representanteid", rpId || "");

                for (const file of selectedFiles) {
                    data.append("files", file);
                }

                setSelectedFiles([]);
                setPreview([]);

                const response = await api.post(url, data);

                toast(`🎉 ${response.data.message}`, { position: "top-center", type: "success" });
                setOpen(false);
                onSuccess();

            } catch (err) {
                setState({ ...state, apiErrors: err.response.data });

                const error = errors.getApiErrors(state.apiErrors);

                if (error !== undefined)
                    toast(error, { position: "top-center", type: "error" });
            }

            setLoading(false);
        } else {
            toast("❌ É necessário inserir no mínimo 3 fotos.", { position: "top-center", type: "error" });
        }

    }

    const handleOpen = () => {
        setState(initialState);
        setSelectedFiles([]);
        setPreview([]);

        setOpen(true);
    }

    const handleClose = () => { setState({ ...state, apiErrors: { errors: [] } }); setOpen(false); }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const getCep = async () => {
        try {
            const endereco = await cep(state.cep);

            setState({
                ...state,
                logradouro: endereco.street,
                bairro: endereco.neighborhood,
                cidade: endereco.city,
                uf: endereco.state
            });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }


    const cadastrarContent = (
        <Modal.Content scrolling>
            {loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!loading &&
                <Form>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="user circle" />Informações Pessoais</Label>
                        <Form.Group widths="equal">
                            <Form.Field width={16} error={hasError("Nome")} required>
                                <label>Nome</label>
                                <Input
                                    icon="user"
                                    iconPosition="left"
                                    placeholder="Nome"
                                    value={state.nome}
                                    onChange={(e: InputProps) => setState({ ...state, nome: e.target.value })}
                                />
                                {hasError("Nome") && <Label pointing prompt>{getMessage("Nome")}</Label>}
                            </Form.Field>
                            <Form.Field error={hasError("Consulta")}>
                                    <label>Cód. Consulta</label>
                                    <Input
                                        placeholder="Cód. Consulta"
                                        value={state.consulta}
                                        onChange={(e: InputProps) => setState({ ...state, consulta: e.target.value })}
                                    />
                                    {hasError("Consulta") && <Label pointing prompt>{getMessage("Consulta")}</Label>}
                                </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field width={4} error={hasError("Nascimento")} required>
                                <label>Data Nasc.</label>
                                <MaskedInput
                                    icon="birthday"
                                    iconPosition="left"
                                    placeholder="Data Nasc."
                                    mask="data"
                                    value={state.nascimento}
                                    onChange={(e: InputProps) => setState({ ...state, nascimento: e.target.value })}
                                />
                                {hasError("Nascimento") && <Label pointing prompt>{getMessage("Nascimento")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Cpf")} required>
                                <label>CPF</label>
                                <MaskedInput
                                    icon="id card"
                                    iconPosition="left"
                                    placeholder="CPF"
                                    mask="cpf"
                                    value={state.cpf}
                                    onChange={(e: InputProps) => setState({ ...state, cpf: e.target.value })}
                                />
                                {hasError("Cpf") && <Label pointing prompt>{getMessage("Cpf")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Rg")} required={!rpId}>
                                    <label>RG</label>
                                    <Input
                                        icon="vcard"
                                        iconPosition="left"
                                        placeholder="RG"
                                        value={state.rg}
                                        onChange={(e: InputProps) => setState({ ...state, rg: e.target.value })}
                                    />
                                    {hasError("Rg") && <Label pointing prompt>{getMessage("Rg")}</Label>}
                                </Form.Field>
                            <Form.Field width={4} error={hasError("Celular")} required>
                                <label>Celular</label>
                                <MaskedInput
                                    icon="call"
                                    iconPosition="left"
                                    placeholder="Celular"
                                    mask="celular"
                                    value={state.celular}
                                    onChange={(e: InputProps) => setState({ ...state, celular: e.target.value })}
                                />
                                {hasError("Celular") && <Label pointing prompt>{getMessage("Celular")}</Label>}
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Segment secondary>
                            <Label size="large" color="pink" attached="top"><Icon name="street view" />Endereço</Label>
                            <Form.Group widths="equal">
                                <Form.Field width={3} error={hasError("Cep")} required>
                                    <label>CEP</label>
                                    <MaskedInput
                                        icon="map marker alternate"
                                        iconPosition="left"
                                        placeholder="Cep"
                                        mask="cep"
                                        value={state.cep}
                                        onChange={(e: InputProps) => setState({ ...state, cep: e.target.value })}
                                        onBlur={getCep}
                                    />
                                    {hasError("Cep") && <Label pointing prompt>{getMessage("Cep")}</Label>}
                                </Form.Field>
                                <Form.Field width={10} error={hasError("Logradouro")} required>
                                    <label>Rua</label>
                                    <Input
                                        icon="road"
                                        iconPosition="left"
                                        placeholder="Rua"
                                        value={state.logradouro}
                                        onChange={(e: InputProps) => setState({ ...state, logradouro: e.target.value })}
                                    />
                                    {hasError("Logradouro") && <Label pointing prompt>{getMessage("Logradouro")}</Label>}
                                </Form.Field>
                                <Form.Field width={3} error={hasError("Numero")} required>
                                    <label>Número</label>
                                    <Input
                                        icon="home"
                                        iconPosition="left"
                                        placeholder="Número"
                                        value={state.numero}
                                        onChange={(e: InputProps) => setState({ ...state, numero: e.target.value })}
                                    />
                                    {hasError("Numero") && <Label pointing prompt>{getMessage("Numero")}</Label>}
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field width={4}>
                                    <label>Complemento</label>
                                    <Input
                                        icon="comment"
                                        iconPosition="left"
                                        placeholder="Complemento"
                                        value={state.complemento}
                                        onChange={(e: InputProps) => setState({ ...state, complemento: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field width={6} error={hasError("Bairro")} required>
                                    <label>Bairro</label>
                                    <Input
                                        icon="industry"
                                        iconPosition="left"
                                        placeholder="Bairro"
                                        value={state.bairro}
                                        onChange={(e: InputProps) => setState({ ...state, bairro: e.target.value })}
                                    />
                                    {hasError("Bairro") && <Label pointing prompt>{getMessage("Bairro")}</Label>}
                                </Form.Field>
                                <Form.Field width={5} error={hasError("Cidade")} required>
                                    <label>Cidade</label>
                                    <Input
                                        icon="building"
                                        iconPosition="left"
                                        placeholder="Cidade"
                                        value={state.cidade}
                                        onChange={(e: InputProps) => setState({ ...state, cidade: e.target.value })}
                                    />
                                    {hasError("Cidade") && <Label pointing prompt>{getMessage("Cidade")}</Label>}
                                </Form.Field>
                                <Form.Field width={2} error={hasError("Uf")} required>
                                    <label>Estado</label>
                                    <Input
                                        icon="flag"
                                        iconPosition="left"
                                        placeholder="Estado"
                                        value={state.uf}
                                        onChange={(e: InputProps) => setState({ ...state, uf: e.target.value })}
                                    />
                                    {hasError("Uf") && <Label pointing prompt>{getMessage("Uf")}</Label>}
                                </Form.Field>
                            </Form.Group>
                        </Segment>
                        <Segment secondary>
                            <Label size="large" color="pink" attached="top"><Icon name="images" />Fotos</Label>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <p>
                                        <strong>
                                            FOTOS NECESSÁRIAS:<br />
                                            - RG; CPF; <br />
                                            - FOTO DE ROSTO SEGURANDO O DOCUMENTO;<br />
                                            - COMPROVANTE DE ENDEREÇO (ATUALIZADO);
                                        </strong>
                                    </p>
                                    <Button
                                        content="Anexar Fotos"
                                        icon="images"
                                        onClick={onButtonClick}
                                        color="blue"
                                        fluid
                                    />
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        hidden
                                        multiple
                                        accept="image/*"
                                        onChange={onSelectFile}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group>
                                <Grid columns={4} doubling>
                                    {preview.length > 0 &&
                                        preview.map((x, index) =>
                                            <Grid.Column key={`image-${index}`}>
                                                <Image
                                                    fluid
                                                    label={<ImageZoom imagePath={x} />}
                                                    src={x}
                                                />
                                                <ModalYesNo
                                                    trigger={<Button icon="trash" color="red" attached="bottom" />}
                                                    header="Apagar"
                                                    content="Deseja realmente apagar esta foto?"
                                                    onSuccess={() => onRemovePreview(x, index)}
                                                />
                                            </Grid.Column>
                                        )}
                                </Grid>
                            </Form.Group>
                        </Segment>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={cadastrarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Novo",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: () => handleSubmitForm(url, status, grId, gsId, rpId) }}
        />
    );
};

export default CadastroPessoa;
